import Layout from '@components/layout';
import CreateGame from '@modules/blackjack/home-create-game';
import LobbyHeading from '@modules/blackjack/home-lobby-heading';
import Lobby from '@modules/blackjack/home-lobby';
import PageEntranceAnimation from '@components/page-entrance-animation';
import useBlackjackLobby from './useBlackjackLobby';

const Views: JSX.Element[] = [
    <CreateGame key={0} />,
    <LobbyHeading key={1} />,
    <Lobby key={2} />,
];

const Blackjack = (): JSX.Element => {
    const [fetched] = useBlackjackLobby();

    return (
        <Layout withSpacing title="blackjack" {...{ fetched }}>
            <PageEntranceAnimation modules={Views} {...{ fetched }} />
        </Layout>
    );
};

export default Blackjack;
